export const Swoosh = ({ className = "" }) => (
  <svg viewBox="0 0 800 800" className={className} aria-hidden="true" preserveAspectRatio="none">
    <defs>
      <linearGradient id="sw-flame" x1="0" y1="1" x2="0.4" y2="0">
        <stop offset="0" stopColor="#E8202A" />
        <stop offset="0.45" stopColor="#F2591B" />
        <stop offset="1" stopColor="#F9A51A" />
      </linearGradient>
      <linearGradient id="sw-water" x1="0" y1="1" x2="0.3" y2="0">
        <stop offset="0" stopColor="#0A4FC4" />
        <stop offset="1" stopColor="#29B2F0" />
      </linearGradient>
    </defs>
    <path d="M800 0C560 120 420 360 470 800H600C540 430 650 190 800 90Z" fill="url(#sw-flame)" />
    <path d="M800 90C650 190 540 430 600 800H660C610 450 700 250 800 170Z" fill="#ffffff" opacity="0.92" />
    <path d="M800 170C700 250 610 450 660 800H760C710 520 740 330 800 260Z" fill="url(#sw-water)" />
  </svg>
);
